@let currentRoom = roomListAccessService.getCurrentModelRoom$() | async;
@if (currentRoom) {
  <mat-card
    (dragover)="onDragOver($event)"
    class="sidebar-container layout-container"
    [attr.data-testid]="testIds.containerRightsidebar">
    <mat-card-content [attr.data-testid]="testIds.containerRightsidebarcontent">
      <span class="subsection">
        <div class="regular scrolled-output" style="overflow-wrap: anywhere">
          <h1 [attr.data-testid]="testIds.textRoomName" style="overflow-wrap: anywhere">
            {{ roomname }}
          </h1>
        </div>
        <div [matTooltip]="currentRoom.creator" class="regular">
          {{ getRoomCreator() }}
        </div>
        <mat-divider />
        <mat-chip-set class="chip-set">
          <app-chip
            [dataTestId]="`chip_room_${currentRoom.isEncrypted ? 'encrypted' : 'unencrypted'}`"
            [avatarIcon]="currentRoom.isEncrypted ? 'lock' : 'lock_open'"
            [avatarIconColor]="currentRoom.isEncrypted ? 'primary' : 'warn'"
            [title]="currentRoom.isEncrypted ? 'Verschlüsselt' : 'Unverschlüsselt'"
            [matTooltip]="`Nachrichten in diesem Raum sind ${currentRoom.isEncrypted ? '' : 'nicht '}Ende-zu-Ende verschlüsselt`">
          </app-chip>
          <app-chip
            [dataTestId]="`chip_room_roomAccess_${currentRoom.roomAccess}`"
            [avatarIcon]="currentRoom.roomAccess === 'public' ? 'globe' : 'key'"
            [matTooltip]="
              currentRoom.roomAccess === 'public'
                ? 'Sichtbar und zugänglich für jeden'
                : 'Beitritt zum Chat nur nach Einladung möglich'
            "
            [title]="currentRoom.roomAccess === 'public' ? 'Öffentlicher Chat' : 'Privater Chat'" />
          <app-chip
            dataTestId="chip_room_historyVisibility"
            [avatarIcon]=""
            [title]="historyVisibilityToText(currentRoom.historyVisibility)"
            [matTooltip]="historyVisibilityTooltip(currentRoom.historyVisibility)" />
        </mat-chip-set>
        <mat-divider />
      </span>
      <span class="subsection">
        <h1 class="description-header">
          <button
            mat-icon-button
            type="button"
            [attr.data-testid]="testIds.buttonDescription"
            (click)="openDialog($event)"
            aria-label="Beschreibung bearbeiten"
            class="clickable">
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
          Beschreibung
        </h1>
        @if (currentRoom.theme) {
          <div
            class="regular scrolled-output"
            style="overflow-wrap: anywhere"
            [attr.data-testid]="testIds.textRoomTopic">
            {{ currentRoom.theme }}
          </div>
        }
        <mat-divider />
      </span>
      <app-dropdown label="Chatmitglieder" [dataTestId]="testIds.dropdownChatParticipant">
        <span class="subsection">
          <mat-list class="scrolled-output" [attr.data-testid]="testIds.listChatParticipant">
            @for (member of currentRoom.members; track member.mxid) {
              @if (member.membershipState === 'join') {
                <mat-list-item
                  [attr.data-testid]="member.mxid"
                  class="user-list"
                  (mouseenter)="showHoverProfile(member.mxid)"
                  (mouseleave)="hideHoverProfile()"
                  (click)="handleUserClick(member.mxid)"
                  (keydown)="$event.stopPropagation()">
                  <app-user-icon
                    [userId]="member.mxid"
                    matListItemAvatar
                    [presenceStatus]="presenceService.getPresence(member.mxid)"></app-user-icon>
                  <div matListItemLine class="member-name-details">
                    <span [matTooltip]="member.rawDisplayName" class="user-name ellipsis">{{
                      member.rawDisplayName
                    }}</span>
                    @if (member.mxid === clientService.getUserId()) {
                      <span class="user-name-specify">Sie</span>
                    }
                  </div>
                  @if (hoveredMemberId === member.mxid && selectedMemberId !== member.mxid) {
                    <div class="hover-preview-container">
                      <app-sb-user-profile-card [member]="member" [isHoverPreview]="true" class="hover-preview">
                      </app-sb-user-profile-card>
                    </div>
                  }
                  @if (selectedMemberId === member.mxid) {
                    <app-sb-user-profile-card [member]="member" [isVisible]="true" (closed)="onProfileClosed()">
                    </app-sb-user-profile-card>
                  }
                  <span matListItemMeta>
                    @if (kickService.isKickable(currentRoom.roomId, member.mxid)) {
                      <mat-icon
                        svgIcon="user-minus"
                        (click)="$event.stopPropagation(); kick(member)"
                        onKeyUp="$event.stopPropagation(); kick(member)"
                        [attr.data-testid]="testIds.iconKickMember"
                        class="kick-icon"
                        matTooltip="Teilnehmer entfernen"></mat-icon>
                    }
                  </span>
                </mat-list-item>
              }
            }
          </mat-list>
          <app-invite-mxid-dialog [isDisabled]="!isRoomMember()" [roomId]="currentRoom.roomId"></app-invite-mxid-dialog>
        </span>
      </app-dropdown>
      <mat-divider />
      <span class="subsection">
        <h1>Chataktionen</h1>
        @if (roomHelperService.getRoomMembership(currentRoom.roomId) !== KnownMembership.Leave) {
          <app-button
            text="Chat verlassen"
            [isPrimary]="true"
            tooltip="Diesen Raum verlassen"
            tooltipPosition="left"
            (clicked)="leaveRoom(currentRoom)"
            [dataTestId]="testIds.buttonLeaveroom"
            [isDisabled]="
              !!currentRoom.tags['m.server_notice'] ||
              (currentRoom.tags['isBlocked'] ? currentRoom.tags['isBlocked']['inProcess'] : !isRoomMember())
            ">
            <mat-icon svgIcon="logout-icon"></mat-icon>
          </app-button>
        } @else {
          <app-button
            text="Chat löschen"
            [isPrimary]="true"
            tooltip="Diesen Raum löschen"
            (clicked)="forgetRoom(currentRoom)"
            tooltipPosition="left"
            [dataTestId]="testIds.buttonForgetroom"
            [isDisabled]="currentRoom.tags['isBlocked'] ? currentRoom.tags['isBlocked']['inProcess'] : false">
            <mat-icon svgIcon="logout-icon"></mat-icon>
          </app-button>
        }

        <app-button
          (clicked)="archive(currentRoom)"
          [dataTestId]="testIds.buttonArchiveroom"
          [isDisabled]="
            currentRoom.tags['isBlocked']
              ? currentRoom.tags['isBlocked']['inProcess'] ||
                roomHelperService.getRoomMembership(currentRoom.roomId) === KnownMembership.Leave
              : !isRoomMember()
          "
          text="Chat archivieren"
          tooltip="Archiviert die Inhalte eines Raumes"
          tooltipPosition="left">
          <mat-icon svgIcon="archive" />
        </app-button>
        @if (roomHelperService.getRoomMembership(currentRoom.roomId) !== KnownMembership.Leave) {
          <app-button
            [dataTestId]="testIds.buttonRoomsettings"
            [isDisabled]="!isRoomMember()"
            text="Chat konfigurieren"
            tooltip="Einstellungen des Raumes"
            tooltipPosition="left"
            (clicked)="openDialog($event)">
            <mat-icon svgIcon="settings-icon" />
          </app-button>
        } @else {
          <app-button
            [dataTestId]="testIds.buttonMedia"
            text="Raummedien"
            tooltip="Medien des Raumes"
            tooltipPosition="left"
            (clicked)="router.navigate(['rooms', chatStoreService.getStateSync().currentRoomId, 'settings', 'media'])">
            <mat-icon svgIcon="settings-icon" />
          </app-button>
        }
        <mat-divider />
      </span>
      <span class="subsection">
        <app-dropdown [dataTestId]="testIds.dropdownPinned" label="Angepinnte Nachrichten">
          @let pinnedMessages = pinnedMessages$ | async;
          @if (pinnedMessages) {
            <span class="subsection">
              <mat-list class="pinned-message-list">
                @for (pinnedMessage of pinnedMessages; track pinnedMessage.messageId) {
                  <div
                    tabindex="0"
                    [attr.data-testid]="testIds.listPinnedmessages"
                    class="pinned-message"
                    (click)="scrollToElement(pinnedMessage.messageId)"
                    (keydown)="onKeyDown($event, pinnedMessage.messageId)">
                    <app-sb-pinned-message [message]="pinnedMessage"></app-sb-pinned-message>
                  </div>
                } @empty {
                  <span>Aktuell sind keine angepinnten Nachrichten vorhanden.</span>
                }
              </mat-list>
            </span>
          }
        </app-dropdown>
      </span>
    </mat-card-content>
    <mat-card-footer class="sidebar-footer">
      <p>
        <button
          (click)="toggleSidebar()"
          [attr.data-testid]="testIds.buttonHideroomsidebar"
          matTooltip="Rauminformationen ausblenden"
          class="room-collapse-btn"
          type="button">
          <mat-icon svgIcon="double-arrow-left"></mat-icon>
        </button>
        <span style="float: right">Fenster einklappen</span>
      </p>
    </mat-card-footer>
  </mat-card>
}
